import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import { store } from '../../../../store/store';
import { NCZICommandContextProvider } from '../../Services/NCZICommandContext';
import NcziQueue from './NcziQueue';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';

loadDOMComponent({
	selector: 'react-nczi-queue',
	// @ts-ignore: TODO: needs typings
	callback: ({ container, context, props }) => {
		const userId = container.getAttribute('userId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<NCZICommandContextProvider>
							<NcziQueue userId={userId} />
						</NCZICommandContextProvider>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
